import React, { useState } from 'react';
import { Box, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import logo from '../../assets/Logo_EssilorLuxottica_black.png';
import './Navbar.css';
import { useAuth } from '../../context/AuthContext'; 


const Navbar: React.FC = () => {
    const navigate = useNavigate();
    const { user, logout } = useAuth();

    const [isLoggingOut, setIsLoggingOut] = useState(false);


    const performLogout = async (): Promise<void> => {
        if (isLoggingOut) return;
        setIsLoggingOut(true);
        try {
            await logout();
        } catch (err) {
            console.error("Errore durante il logout:", err);
        } finally {
            setIsLoggingOut(false);
        }
    };

    const goToHome = () => {
        navigate("/");
    };

    return (
        <div className="navbar">
            <Box className="logo-box" onClick={goToHome} >

                <img className="el-logo" src={logo} alt="Logo" />
                <h1 className="elwo-text">Document Editor</h1>
            </Box>
            {user && (
                <div className="navbar-user">
                    <span style={{ display: 'flex', alignItems: 'center' }}> Welcome back <strong style={{ marginRight: '5px', marginLeft: '5px' }}>{user.name}</strong> <small>({user.username?.toLowerCase()})</small></span>
                    &nbsp;
                    <div onClick={performLogout} className="so-btn" style={{ marginLeft: '10px', cursor: 'pointer' }}>
                        <Icon as={FaSignOutAlt} boxSize={3} />
                    </div>
                </div>
            )}

        </div>
    );
};

export default Navbar;